import React, {useEffect, useRef} from "react";
import Button from "../Global/Button";
import Image from "../Global/Image";
import Link from "../Pictos/Link";

import styles from "./ArticleLink.module.scss";
import ScrollMagic from "scrollmagic";
import {TimelineMax} from "gsap";

export default function ArticleLink ({title, url,  image, classname}) {

    const article = useRef(null);

    useEffect(() => {
        const controller = new ScrollMagic.Controller({
            refreshIntervals: 0
        });


        new ScrollMagic.Scene({
            triggerHook: 'onEnter', triggerElement: article.current, duration: "200%", reverse: true
        })
            .setTween(
                new TimelineMax().to(article.current.querySelector('figure'), 1, {
                    x: ((article.current.getBoundingClientRect().width - window.innerWidth)) / 2,
                }, 'start'))
            .addTo(controller);
    }, []);

    return (
        <div className={[styles.Main, classname ?? ''].join(' ')} ref={article}>
            <Image {...image}
                   classname={styles.Background}/>
            <div className={styles.MastheadText}>
                <h2>
                    {title}
                </h2>

                <Button text={"Lire l'article"} target={'_blank'} url={url}>
                    <Link/>
                </Button>
            </div>
        </div>
    )
}
